import React, { useState, useEffect } from "react";

const ConsentBanner = () => {
  const [isConsentGiven, setIsConsentGiven] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("userConsent");
    if (consent === "accepted") {
      setIsConsentGiven(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("userConsent", "accepted");
    setIsConsentGiven(true);
  };

  if (isConsentGiven) {
    return null;
  }

  return (
    <div style={bannerStyle}>
      We use cookies to improve your experience. By clicking "Accept", you
      consent to our data policies.
      <button onClick={handleAccept} style={buttonStyle}>
        Accept
      </button>
    </div>
  );
};

const bannerStyle = {
  position: "fixed",
  bottom: "0",
  left: 0,
  right: 0,
  width: "100%",
  backgroundColor: "#f1f1f1",
  padding: "10px",
  textAlign: "center",
  boxShadow: "0px -2px 5px rgba(0,0,0,0.1)",
};

const buttonStyle = {
  marginLeft: "10px",
  padding: "5px 10px",
  backgroundColor: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "3px",
  cursor: "pointer",
};

export default ConsentBanner;
